import { GetHelpExperienceResponse } from '../../models/getHelp/experienceConfigurations';

// We will union more types to this type
export type ActionPayload = string | string[] | GetHelpExperienceResponse;

export type Action<P = ActionPayload> = {
  readonly type: string;
  readonly payload?: P;
};

export const createAction = <T extends string, P>(type: T, payload: P): Action<P> => {
  return { type, payload };
};
